function getStr(diffNum: number, label: string) {
    const roundVal = Math.round(diffNum);
    return roundVal === 1 ? `${roundVal} ${label}` : `${roundVal} ${label}s`;
}

export function getTimeDiffString(t1: string, t2?: string) {
    const t1Ms = Date.parse(t1);
    const t2Ms = t2 ? Date.parse(t2) : Date.now();
    const diffSecs = (t2Ms - t1Ms) / 1000;

    const min = 60;
    const hour = min * 60;
    const day = hour * 24;
    const week = day * 7;
    const month = day * 30;
    const year = day * 365;
    switch (true) {
        case diffSecs < min:
            return getStr(diffSecs, "Second");
        case diffSecs >= min && diffSecs < hour:
            return getStr(diffSecs / min, "Minute");
        case diffSecs >= hour && diffSecs < day:
            return getStr(diffSecs / hour, "Hour");
        case diffSecs >= day && diffSecs < week:
            return getStr(diffSecs / day, "Day");
        case diffSecs >= week && diffSecs < month:
            return getStr(diffSecs / week, "Week");
        case diffSecs >= month && diffSecs < year:
            return getStr(diffSecs / month, "Month");
        default:
            return getStr(diffSecs / year, "Year");
    }
}
